import { useEffect, useState } from "react";
import getPlaces, { Place as ApiPlace, getPlaceCode } from "../../api/PlacesApi";

type Place = {
  id: string;
  nome: string;
};

type UsePlacesResult = {
  places: Place[];
};

function mapCityToPlace(city: ApiPlace): Place | null {
  const cityRecord = city as Record<string, unknown>;
  const id = getPlaceCode(city);

  if (typeof id !== "string" || id.trim().length === 0) {
    return null;
  }

  const nome =
    typeof cityRecord.nome === "string" && cityRecord.nome.trim().length > 0
      ? cityRecord.nome
      : typeof cityRecord.name === "string" && cityRecord.name.trim().length > 0
        ? cityRecord.name
        : String(id);

  return {
    id,
    nome,
  };
}

export default function usePlaces(): UsePlacesResult {
  const [places, setPlaces] = useState<Place[]>([]);

  useEffect(() => {
    let isMounted = true;

    async function loadPlaces() {
      try {
        const response = await getPlaces();
        const normalizedPlaces = response
          .map(mapCityToPlace)
          .filter((place): place is Place => place !== null)
          .sort((a, b) => a.nome.localeCompare(b.nome, undefined, { sensitivity: "base" }));

        if (isMounted) {
          setPlaces(normalizedPlaces);
        }
      } catch (error) {
        console.error("Erro ao carregar locais:", error);

        if (isMounted) {
          setPlaces([]);
        }
      }
    }

    loadPlaces();

    return () => {
      isMounted = false;
    };
  }, []);

  return { places };
}
